<template>
    <div class="animated fadeIn">
        <b-card >
            <template v-slot:header>
                <h5>Edit Gadai Kendaraan</h5>
            </template>
            <b-alert variant="primary" show>* Sedang dalam verifikasi AM</b-alert>
            <b-form @submit.prevent="openModalConfirm">
                <div class="detail-data-wrapper mb-4">
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label"><strong>No. Faktur</strong></b-col>
                        <b-col v-if="dataStagingKend.noFaktur != null"><strong>{{ dataStagingKend.noFaktur }}</strong></b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Status Gadai</b-col>
                        <b-col v-if="dataStagingKend.statusGadai != null">{{ dataStagingKend.statusGadai }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">DATA ANGGOTA</h6>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">No. Anggota</b-col>
                        <b-col v-if="dataStagingKend.anggota.noAnggota != null"><strong>{{ dataStagingKend.anggota.noAnggota }}</strong></b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Jenis Identitas</b-col>
                        <b-col v-if="dataStagingKend.anggota.jenisIdentitas != null">{{ dataStagingKend.anggota.jenisIdentitas }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">No. Identitas</b-col>
                        <b-col v-if="dataStagingKend.anggota.noIdentitas != null">{{ dataStagingKend.anggota.noIdentitas }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Nama</b-col>
                        <b-col v-if="dataStagingKend.anggota.namaAnggota != null">{{ dataStagingKend.anggota.namaAnggota }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Alamat</b-col>
                        <b-col v-if="dataStagingKend.anggota.alamat != null">{{ dataStagingKend.anggota.alamat }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">No. Handphone</b-col>
                        <b-col v-if="dataStagingKend.anggota.noHp != null">{{ dataStagingKend.anggota.noHp }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">DATA KENDARAAN</h6>
                    <b-row>
                        <b-col lg="4" md="6" cols="6">
                            <h6 class="compare-text-title">Data Sekarang</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Tipe Pinjaman</div>
                                <div v-if="dataStagingKend.barangLama.kendaraan.withKendaraan == true">Kendaraan + BPKB</div>
                                <div v-else>BPKB Saja</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Jenis Kendaraan</div>
                                <div v-if="dataStagingKend.barangLama.jenis != null">{{ dataStagingKend.barangLama.jenis.name }}</div>
                                <div v-else>-</div>    
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Merk Kendaraan</div>
                                <div v-if="dataStagingKend.barangLama.merk != null">{{ dataStagingKend.barangLama.merk.name }}</div>
                                <div v-else>-</div>           
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Tipe Kendaraan</div>
                                <div v-if="dataStagingKend.barangLama.tipe != null">{{ dataStagingKend.barangLama.tipe.name }}</div>
                                <div v-else>-</div>              
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Tahun</div>
                                <div v-if="dataStagingKend.barangLama.tahun != null">{{ dataStagingKend.barangLama.tahun }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Tahun</div>
                                <div v-if="dataStagingKend.barangLama.tahun != null">{{ dataStagingKend.barangLama.tahun }}</div>
                                <div v-else>-</div>              
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kondisi / Grade Kendaraan</div>
                                <div v-if="dataStagingKend.barangLama.gradeKondisi != null">{{ dataStagingKend.barangLama.gradeKondisi.name }}</div>
                                <div v-else>-</div>       
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Warna Kendaraan</div>
                                <div v-if="dataStagingKend.barangLama.warna != null">{{ dataStagingKend.barangLama.warna.name }}</div>
                                <div v-else>-</div>                 
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Status Kendaraan</div>
                                <div v-if="dataStagingKend.barangLama.kendaraan.status != null">{{ dataStagingKend.barangLama.kendaraan.status }}</div>
                                <div v-else>-</div>                    
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">No. Polisi</div>
                                <div v-if="dataStagingKend.barangLama.kendaraan.noPolisi != null">{{ dataStagingKend.barangLama.kendaraan.noPolisi }}</div>
                                <div v-else>-</div>                
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kelengkapan Kendaraan</div>
                                <div v-if="dataStagingKend.barangLama.kelengkapan.length >= 1">
                                    <ul class="list-circle-wrapper">
                                        <li v-for="item in dataStagingKend.barangLama.kelengkapan"  v-bind:key="item">
                                            {{ item }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>-</div>    
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Spesifikasi Kendaraan</div>
                                <div v-if="dataStagingKend.barangLama.spesifikasi.length >= 1">
                                    <ul class="list-circle-wrapper">
                                        <li v-for="(item, idx) in dataStagingKend.barangLama.spesifikasi"  v-bind:key="idx">
                                            {{ item.name }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>-</div>             
                            </div>
                        </b-col>
                        <b-col lg="4" md="6" cols="6" class="comparison-separator">
                            <h6 class="compare-text-title">Data Perubahan</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Tipe Pinjaman</div>
                                <div v-if="dataStagingKend.barangBaru.kendaraan.withKendaraan == true">Kendaraan + BPKB</div>
                                <div v-else>BPKB Saja</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Jenis Kendaraan</div>
                                <div v-if="dataStagingKend.barangBaru.jenis != null">{{ dataStagingKend.barangBaru.jenis.name }}</div>
                                <div v-else>-</div>    
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Merk Kendaraan</div>
                                <div v-if="dataStagingKend.barangBaru.merk != null">{{ dataStagingKend.barangBaru.merk.name }}</div>
                                <div v-else>-</div>           
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Tipe Kendaraan</div>
                                <div v-if="dataStagingKend.barangBaru.tipe != null">{{ dataStagingKend.barangBaru.tipe.name }}</div>
                                <div v-else>-</div>              
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Tahun</div>
                                <div v-if="dataStagingKend.barangBaru.tahun != null">{{ dataStagingKend.barangBaru.tahun }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Tahun</div>
                                <div v-if="dataStagingKend.barangBaru.tahun != null">{{ dataStagingKend.barangBaru.tahun }}</div>
                                <div v-else>-</div>              
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kondisi / Grade Kendaraan</div>
                                <div v-if="dataStagingKend.barangBaru.gradeKondisi != null">{{ dataStagingKend.barangBaru.gradeKondisi.name }}</div>
                                <div v-else>-</div>       
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Warna Kendaraan</div>
                                <div v-if="dataStagingKend.barangBaru.warna != null">{{ dataStagingKend.barangBaru.warna.name }}</div>
                                <div v-else>-</div>                 
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Status Kendaraan</div>
                                <div v-if="dataStagingKend.barangBaru.kendaraan.status != null">{{ dataStagingKend.barangBaru.kendaraan.status }}</div>
                                <div v-else>-</div>                    
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">No. Polisi</div>
                                <div v-if="dataStagingKend.barangBaru.kendaraan.noPolisi != null">{{ dataStagingKend.barangBaru.kendaraan.noPolisi }}</div>
                                <div v-else>-</div>                
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kelengkapan Kendaraan</div>
                                <div v-if="dataStagingKend.barangBaru.kelengkapan.length >= 1">
                                    <ul class="list-circle-wrapper">
                                        <li v-for="item in dataStagingKend.barangBaru.kelengkapan"  v-bind:key="item">
                                            {{ item }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>-</div>    
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Spesifikasi Kendaraan</div>
                                <div v-if="dataStagingKend.barangBaru.spesifikasi.length >= 1">
                                    <ul class="list-circle-wrapper">
                                        <li v-for="(item, idx) in dataStagingKend.barangBaru.spesifikasi"  v-bind:key="idx">
                                            {{ item.name }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>-</div>             
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">DATA STNK</h6>
                    <b-row>
                        <b-col lg="4" md="6" cols="6">
                            <h6 class="compare-text-title">Data Sekarang</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">STNK Atas Nama</div>
                                <div v-if="dataStagingKend.barangLama.kendaraan.namaSTNK != null">{{ dataStagingKend.barangLama.kendaraan.namaSTNK }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Alamat STNK</div>
                                <div v-if="dataStagingKend.barangLama.kendaraan.alamatSTNK != null">{{ dataStagingKend.barangLama.kendaraan.alamatSTNK }}</div>
                                <div v-else>-</div>              
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Masa berlaku pajak STNK</div>
                                <div v-if="dataStagingKend.barangLama.kendaraan.pajakSTNK != null">{{$helper.changeDateFormat(dataStagingKend.barangLama.kendaraan.pajakSTNK) }}</div>
                                <div v-else>-</div>                        
                            </div>
                        </b-col>
                        <b-col lg="4" md="6" cols="6" class="comparison-separator">
                            <h6 class="compare-text-title">Data Perubahan</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">STNK Atas Nama</div>
                                <div v-if="dataStagingKend.barangBaru.kendaraan.namaSTNK != null">{{ dataStagingKend.barangBaru.kendaraan.namaSTNK }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Alamat STNK</div>
                                <div v-if="dataStagingKend.barangBaru.kendaraan.alamatSTNK != null">{{ dataStagingKend.barangBaru.kendaraan.alamatSTNK }}</div>
                                <div v-else>-</div>              
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Masa berlaku pajak STNK</div>
                                <div v-if="dataStagingKend.barangBaru.kendaraan.pajakSTNK != null">{{$helper.changeDateFormat(dataStagingKend.barangBaru.kendaraan.pajakSTNK) }}</div>
                                <div v-else>-</div>                        
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">DATA BPKB</h6>
                    <b-row>
                        <b-col lg="4" md="6" cols="6">
                            <h6 class="compare-text-title">Data Sekarang</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">No. BPKB</div>
                                <div v-if="dataStagingKend.barangLama.kendaraan.noBPKB != null">{{ dataStagingKend.barangLama.kendaraan.noBPKB }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">BPKB Atas Nama</div>
                                <div v-if="dataStagingKend.barangLama.kendaraan.namaBPKB != null">{{ dataStagingKend.barangLama.kendaraan.namaBPKB }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">No. Mesin</div>
                                <div v-if="dataStagingKend.barangLama.kendaraan.noMesin != null">{{ dataStagingKend.barangLama.kendaraan.noMesin }}</div>
                                <div v-else>-</div>             
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">No. Rangka</div>
                                <div v-if="dataStagingKend.barangLama.kendaraan.noRangka != null">{{ dataStagingKend.barangLama.kendaraan.noRangka }}</div>
                                <div v-else>-</div>
                            </div>
                        </b-col>
                        <b-col lg="4" md="6" cols="6" class="comparison-separator">
                            <h6 class="compare-text-title">Data Perubahan</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">No. BPKB</div>
                                <div v-if="dataStagingKend.barangBaru.kendaraan.noBPKB != null">{{ dataStagingKend.barangBaru.kendaraan.noBPKB }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">BPKB Atas Nama</div>
                                <div v-if="dataStagingKend.barangBaru.kendaraan.namaBPKB != null">{{ dataStagingKend.barangBaru.kendaraan.namaBPKB }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">No. Mesin</div>
                                <div v-if="dataStagingKend.barangBaru.kendaraan.noMesin != null">{{ dataStagingKend.barangBaru.kendaraan.noMesin }}</div>
                                <div v-else>-</div>             
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">No. Rangka</div>
                                <div v-if="dataStagingKend.barangBaru.kendaraan.noRangka != null">{{ dataStagingKend.barangBaru.kendaraan.noRangka }}</div>
                                <div v-else>-</div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">DATA PENDUKUNG</h6>
                    <b-row>
                        <b-col lg="4" md="6" cols="6">
                            <h6 class="compare-text-title">Data Sekarang</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Foto</div>
                                <div v-if="$helper.isNotNullAndNotEmpty(dataStagingKend.fotoLama)">
                                    <span class="mr-1" v-for="(item, idx) in dataStagingKend.fotoLama"  v-bind:key="idx">
                                        <a v-bind:href="item.name" target="_blank">
                                            <img width="150px" :src="item.name" alt="Foto Pendukung">
                                        </a>
                                    </span>
                                </div>
                                <div v-else>-</div>
                            </div>
                        </b-col>
                        <b-col lg="4" md="6" cols="6" class="comparison-separator">
                            <h6 class="compare-text-title">Data Perubahan</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Foto</div>
                                <div v-if="$helper.isNotNullAndNotEmpty(dataStagingKend.fotoBaru)">
                                    <span class="mr-1" v-for="(item, idx) in dataStagingKend.fotoBaru"  v-bind:key="idx">
                                        <a v-bind:href="item.name" target="_blank">
                                            <img width="150px" :src="item.name" alt="Foto Pendukung">
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">ALASAN PERUBAHAN</h6>
                    <b-row class="mb-2">
                        <b-col lg="4" md="6" cols="6" class="detail-data-label">Keterangan</b-col>
                        <b-col v-if="dataStagingKend.keterangan != null">{{ dataStagingKend.keterangan }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col lg="4" md="6" cols="6" class="detail-data-label">Diajukan pada</b-col>
                        <b-col>{{ $helper.changeDateFormat(dataStagingKend.createdAt )}} {{ $helper.changeDateFormatGetHour(dataStagingKend.createdAt )}}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col lg="4" md="6" cols="6" class="detail-data-label">Diajukan oleh</b-col>
                        <b-col>{{ dataStagingKend.createdBy }}</b-col>
                    </b-row>
                </div>
            </b-form>
        </b-card>
    </div>
</template>

<script>

export default {
    name: 'edit-gadai-kendaraan',
    data(){
        return{
            initStatus: 0,
            dataStagingKend: {
                anggota: [],
                barangLama: {
                    kendaraan: {},
                    kelengkapan: {},
                    spesifikasi: {}
                },
                barangBaru: {
                    kendaraan: {},
                    kelengkapan: {},
                    spesifikasi: {}
                }
            }
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id
            
            let getEditStagingKend = this.$axios.get(`gadai/daftar-gadai/${this.id}/staging`).then(response => {
                this.dataStagingKend = response.data
         
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getEditStagingKend]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                const noFaktur = this.$route.path.split('/')[3];
                const message = this.$helper.parseError(this, error, '', false)
                if (message == 'Gadai ini tidak dalam verifikasi edit - tidak dapat menampilkan data!') {
                    this.$router.push(`/gadai/inquiry-faktur/${noFaktur}`);
                }
                this.initStatus = -1
            })
        },

        
    },
    created(){
        this.init()
    }
}
</script>
